import React from 'react'

const componentPromise = import('./cookies' /* webpackChunkName: "cookiesPage"*/)

const Component = React.lazy(() => componentPromise)

export default Component